export default "__VITE_ASSET__DtAqhosK__"